<template>
  <div>
    <CCardBody>
      <div class="d-flex gap-1 justify-content-end text-right btngroup">
        <CButton class="addBtn" @click="showModal"> Create </CButton>
      </div>
      <search-items
        v-model="search"
        :searchHandler="getDesignCategories"
        placeholder="Search name"
      ></search-items>
      <b-table :items="designCategories" :fields="headers" hover sorter>
        <template #cell(name)="item">
          <span>{{ item.item.category_name }}</span>
        </template>
        <template #cell(actions)="item">
          <edit
            class="delete_step ml-2 cursor-pointer"
            @click="editDesignCategory(item.item)"
            fillColor="#009FE3"
          />
          <delete
            class="delete_step ml-2 cursor-pointer"
            @click="deleteDesignCategory(item.item)"
            fillColor="#E30000"
          />
        </template>
      </b-table>
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.rows"
        :per-page="pagination.perPage"
        aria-controls="itemList"
        align="center"
        @change="handlePagination"
        v-if="pagination.total > 0"
      ></b-pagination>
    </CCardBody>
    <b-modal
      id="priceListModal"
      @hide="resetForm"
      size="md"
      no-close-on-backdrop
      hide-footer
    >
      <template #modal-title>
        <span>Create Design Category</span>
      </template>
      <b-form-group id="name" label-for="name">
        <CContainer>
          <CRow>
            <CCol col="12">
              <label>Name</label>
              <b-form-input
                v-model="designCategory.name"
                class="mb-4"
              ></b-form-input>
            </CCol>
          </CRow>
        </CContainer>
      </b-form-group>
      <CRow>
        <CCol col="12" class="text-right">
          <button @click="createEditDesignCategory" class="btn btn-primary">
            Save
          </button>
        </CCol>
      </CRow>
    </b-modal>
    <b-modal id="deletePriceListModal" size="md" no-close-on-backdrop>
      <template #modal-title>
        <span>Delete design category</span>
      </template>
      <span class="font-md"
        ><strong>Warning:</strong> Deleting this design category will remove
        this category from all designs associated with it.</span
      >
      <template #modal-footer="{ hide }">
        <b-button size="md" variant="danger" @click="confirmDelete"
          >Delete</b-button
        >
        <b-button size="md" @click="hide()">Cancel</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import myMixins from "@/mixins/myMixins";
import Delete from "vue-material-design-icons/Delete.vue";
import Edit from "vue-material-design-icons/Pencil.vue";
import SearchItems from "../../components/SearchItems";
import { http } from "../../config/httpCommon";

export default {
  components: { SearchItems, Delete, Edit },
  mixins: [myMixins],
  created() {
    this.getDesignCategories();
  },
  data() {
    return {
      search: "",
      headers: [
        { key: "name", label: "Name" },
        { key: "actions", label: "Actions" },
      ],
      designCategory: {
        name: "",
      },
      mode: "create",
      pagination: {
        rows: null,
        currentPage: null,
        perPage: null,
        total: 0,
      },
      designCategories: [],
      designCategoryId: null,
    };
  },
  methods: {
    getDesignCategories() {
      this.$store.dispatch("getDesignCategories").then((res) => {
        this.designCategories = res.data.result.data;
        this.makePagination(res.data.result.data);
      });
    },
    createEditDesignCategory() {
      this.$store.commit("set", ["showLoader", true]);
      if (this.mode === "create") {
        this.$store
          .dispatch("createDesignCategory", this.designCategory.name)
          .then((res) => {
            this.getDesignCategories();
            this.$bvModal.hide("priceListModal");
            this.showToast("Design category added successfully", "SUCCESS");
            this.$store.commit("set", ["showLoader", false]);
          })
          .catch((err) => {
            this.showError(err);
            console.log("err", err);
            this.$store.commit("set", ["showLoader", false]);
          });
      } else {
        this.$store
          .dispatch("editDesignCategory", {
            category_id: this.designCategory.id,
            category_name: this.designCategory.name,
          })
          .then((res) => {
            this.getDesignCategories();
            this.$bvModal.hide("priceListModal");
            this.showToast("Design category updated successfully", "SUCCESS");
            this.$store.commit("set", ["showLoader", false]);
          })
          .catch((err) => {
            this.showError(err);
            console.log("err", err);
            this.$store.commit("set", ["showLoader", false]);
          });
      }
    },
    editDesignCategory(item) {
      this.mode = "edit";
      this.designCategory.id = item.id;
      this.designCategory.name = item.category_name;
      this.$bvModal.show("priceListModal");
    },
    deleteDesignCategory(item) {
      this.designCategory.id = item.id;
      this.$bvModal.show("deletePriceListModal");
    },
    confirmDelete() {
      this.$store.commit("set", ["showLoader", true]);
      this.$store
        .dispatch("deleteDesignCategory", {
          category_id: this.designCategory.id,
        })
        .then((res) => {
          this.getDesignCategories();
          this.$bvModal.hide("deletePriceListModal");
          this.showToast("Design category deleted successfully", "SUCCESS");
          this.$store.commit("set", ["showLoader", false]);
        })
        .catch((err) => {
          this.showError(err);
          console.log("err", err);
          this.$store.commit("set", ["showLoader", false]);
        });
    },
    showModal() {
      this.$bvModal.show("priceListModal");
    },
    resetForm() {
      this.designCategory = {
        name: "",
      };
      this.mode = "create";
      this.designCategoryId = null;
    },
    async handlePagination(page = "") {
      this.setFilters({ page: page });
      this.getDesignCategories();
    },
  },
};
</script>
